/**
 * 群公告条（21ah；旧版 chat_screen.dart `_buildGroupAnnouncementPinnedBar`）。
 *
 * 旧版在群聊顶部挂一条公告横幅，点击弹全文对话框。新版两处刻意偏差：
 * - **点击直接进群公告页**（`/chat/group/<id>/settings/notice`，14.28 已有），
 *   不另做一个只读对话框：那个页面成员只读、管理员可编辑，功能是对话框的超集，
 *   还省掉一套浮层与它的层级/关闭口径。
 * - 不渲染旧版正文里那个重复的 `[群公告]` 前缀——标题行已经写着「群公告」了。
 *
 * 形态与置顶横幅（PinBanner）一致并共用它的样式：都走**文档流挤占列表高度**
 * （14.9 选择条同策——absolute 覆盖层会遮住粘底的最新行）。两条并存时公告在上。
 */
import { noticePreview } from './groupNoticeModel';
import { IconMegaphone } from '~/ui/icons';
import styles from './pinBanner.module.scss';

export function NoticeBanner({ notice, onOpen }: { notice: string; onOpen: () => void }) {
  const preview = noticePreview(notice);
  // 空公告由调用方（shouldShowNoticeBanner）拦住，这里是防御
  if (preview === '') return null;
  return (
    <button
      type="button"
      className={styles.noticeBar}
      data-testid="chat-notice-banner"
      onClick={onOpen}
    >
      <IconMegaphone class={styles.noticeIcon} />
      <span className={styles.noticeText}>
        <span className={styles.title}>群公告</span>
        <span className={styles.preview} data-testid="chat-notice-preview">
          {preview}
        </span>
      </span>
    </button>
  );
}
